export default __webpack_public_path__ + "static/British_Land_logo_blue-c27a9ba4e2ad13f81e53081c6206fb1a.png";